<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <div class="mt-2 font-weight-bold text-h5">
          請至對應平台（App Store/ Play 商店） 進行下載
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex flex-column align-center">
          <v-btn
            :loading="loading3"
            :disabled="loading3"
            color="#000000"
            class="ma-2 white--text"
            style="min-width: 250px"
            x-large
            href="https://apps.apple.com/tw/app/%E7%B5%B1%E4%B8%80%E4%BC%81%E6%A5%AD%E9%9B%86%E5%9C%98%E7%89%B9%E7%B4%84%E5%95%86%E5%BA%97/id1633000841"
            ><v-icon left dark> mdi-apple </v-icon>
            在 App Store 下載
          </v-btn>
          <v-btn
            :loading="loading3"
            :disabled="loading3"
            color="#3DDC84"
            class="ma-2 white--text"
            style="min-width: 250px"
            x-large
            href="https://play.google.com/store/apps/details?id=com.pec.eps&hl=zh_TW"
            ><v-icon left dark> mdi-android </v-icon>
            在 Google Play 下載
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "finishSignIn ",

  data: () => ({}),
};
</script>
